import { render } from "./ApplicationStep2.vue?vue&type=template&id=54299ffb"
import script from "./ApplicationStep2.vue?vue&type=script&lang=js"
export * from "./ApplicationStep2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__